interface UserITF {
  username?: string;
  verifierPushToken?: any;
  email?: string;
  accountIcon?: string;
  accountLabel?: string;
  accountColor?: string;
  isFirstTimeLogin?: boolean;
}

interface AccountITF {
  email?: string;
  accountIcon?: string;
  accountLabel?: string;
  accountColor?: string;
  identity?: string;
  isFirstTimeLogin?: boolean;
}

interface RegisterUserITF {
  username: string;
  email: string;
}

export const setUsername = async (username: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/username`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const setEmail = async (id: string, email: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/email`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, email }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

// export const setUsernameAndEmail = async (username: string, email: string) => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_URL}/user/username-email`,
//       {
//         method: "POST",
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ username, email }),
//       }
//     );
//     return await response.json();
//   } catch (error) {
//     console.log(error);
//   }
// };

export const registerUser = async ({
  email,
  username,
}: RegisterUserITF) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username, email }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const setAlias = async (
  identity: string,
  alias: string,
  payload?: any
) => {
  try {
    const bodyPayload: any = {
      alias,
      identity,
    };

    if (payload) {
      bodyPayload.payload = payload;
    }

    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/alias`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyPayload),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const getAlias = async (id: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/alias/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const getAliases = async (identity: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/aliases/${identity}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const updateAlias = async (id: string, payload: any) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/alias`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, payload }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const disableAlias = async (alias: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/alias-disable`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ alias }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const getUserByIdentity = async (identity: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/identity/${identity}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const getUserByEmail = async (email: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/email/${email}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const recoverIdentity = async (email: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/recover-identity/${email}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const updateUser = async (identity: string, payload: UserITF) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/user`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ identity, payload }),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const createAccount = async (payload: AccountITF) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/account`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const requestCreateAccount = async (
  email: string,
  clientReferenceId: string
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/account-create-request`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, clientReferenceId }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const requestRecoverAccount = async (
  email: string,
  clientReferenceId: string
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/account-recover-request`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, clientReferenceId }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const loginIdentity = async (alias: string, did?: string, internalId?: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/login`,
      {
        method: "POST",
        body: JSON.stringify({
          alias,
          did,
          internalId,
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};

export const userRemovePushToken = async (
  identity: string,
  pushToken: string
) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/user/remove-push-token`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ identity, pushToken }),
      }
    );
    return await response.json();
  } catch (error) {
    console.log(error);
  }
};
